/**
 * В API `moduleSlug` для опросов — строка (в т.ч. кастомные модули на базе SURVEY).
 * Здесь — только встроенные слаги: проектные опросы и «обращение депутату».
 */
export enum SurveyModuleSlugEnum {
  ProjectSurvey = 'project_survey',
  QuestionToDeputy = 'question_to_deputy',
}
